import React from "react";
import { PageMessage } from "@picklebet/ui";
import NextBettingButtons from "@/features/shell/components/shared/NextBettingButtons";
import { useIsMobile } from "@/hooks/useDisplay";
import { ReactComponent as EmptyIcon } from "@/features/betslip/assets/empty.svg";
import * as styles from "./Empty.module.scss";

export const Empty = () => {
  const isMobile = useIsMobile();
  const btnVariant = isMobile ? "primary" : "blurred";

  return (
    <PageMessage
      className={styles.container}
      image={<EmptyIcon />}
      title="Your Betslip is Empty"
      subTitle="Check out today’s action to make a bet"
    >
      <NextBettingButtons
        className={styles.buttons}
        variant={btnVariant}
        size="md"
      />
    </PageMessage>
  );
};
